export default __webpack_public_path__ + "static/media/book_image3.82a5dd03.jfif";